import { render } from "./KuFooter.vue?vue&type=template&id=4821c9bb"
import script from "./KuFooter.vue?vue&type=script&lang=js"
export * from "./KuFooter.vue?vue&type=script&lang=js"

import "./KuFooter.vue?vue&type=style&index=0&id=4821c9bb&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1d9c808fc766473613eb0f9d559345b4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__